/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagTagidLangsAvailableLanguages200,
  GetApiV1TagTagidLangsAvailableLanguages401,
  GetApiV1TagTagidLangsAvailableLanguages404,
  GetApiV1TagTagidLangsAvailableLanguages500,
  GetApiV1TagTagidLangsAvailableLanguagesPathParams,
  GetApiV1TagTagidLangsAvailableLanguagesQueryResponse,
} from "../../types/tagIdiomasController/GetApiV1TagTagidLangsAvailableLanguages.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1TagTagidLangsAvailableLanguagesPathParamsSchema = z.object(
  {
    tagId: z.coerce.number().int(),
  },
) as unknown as ToZod<GetApiV1TagTagidLangsAvailableLanguagesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagTagidLangsAvailableLanguages200Schema = z.array(
  z.lazy(() => dropDownListStringKeyViewModelSchema),
) as unknown as ToZod<GetApiV1TagTagidLangsAvailableLanguages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagTagidLangsAvailableLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1TagTagidLangsAvailableLanguages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1TagTagidLangsAvailableLanguages404Schema =
  z.any() as unknown as ToZod<GetApiV1TagTagidLangsAvailableLanguages404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagTagidLangsAvailableLanguages500Schema =
  z.any() as unknown as ToZod<GetApiV1TagTagidLangsAvailableLanguages500>;

export const getApiV1TagTagidLangsAvailableLanguagesQueryResponseSchema =
  z.lazy(
    () => getApiV1TagTagidLangsAvailableLanguages200Schema,
  ) as unknown as ToZod<GetApiV1TagTagidLangsAvailableLanguagesQueryResponse>;
